import { Outlet } from "react-router-dom";

const Layout = () => {
    return (
        <div className="admin admin-auth-layout">
            <Outlet />
        </div>
    );
};

export default Layout;